var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneytransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_934)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.526 133.755H259.898M388.526 133.755L372.437 111.479M388.526 133.755L372.437 156.004",
    stroke: "black",
    strokeWidth: 13.5629,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.483 367.82H250.039M111.483 367.82L128.813 345.235M111.483 367.82L128.813 390.378",
    stroke: "black",
    strokeWidth: 13.5629,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.532,
    cy: 250.001,
    r: 116.899,
    fill: "#FEF4E8",
    stroke: "#9f86c0",
    strokeWidth: 13.5629
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25 191.871H295.773V203.182H261.239C261.239 203.182 272.219 214.946 272.219 222.638H295.672V233.044H273.216C273.216 233.044 268.725 268.154 225.708 265.982L278.208 323.264H257.248L204.25 267.974V256.391C204.25 256.391 230.3 257.114 242.775 249.423C252.856 243.18 251.558 239.378 252.456 235.758C252.757 234.401 251.657 233.135 250.16 233.135H204.25V222.728H251.26C252.256 222.728 252.856 221.823 252.357 221.008C250.36 217.48 245.071 209.606 237.786 208.159C228.303 206.35 204.25 205.896 204.25 205.896V191.871Z",
    fill: "#9f86c0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneytransfer);
export default __webpack_public_path__ + "static/media/money transfer.0808839ea511fdad9d69d7ca514c0913.svg";
export { ForwardRef as ReactComponent };